import { useState, useEffect } from 'react';
import { DEVICE_BREAKPOINT } from 'utils/constants';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

interface DeviceInfo {
  deviceType: DeviceType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const useDeviceType = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    deviceType: 'desktop',
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  const getDeviceType = (): DeviceInfo => {
    const width = window.innerWidth;

    if (width < DEVICE_BREAKPOINT.MOBILE) {
      return { deviceType: 'mobile', isMobile: true, isTablet: false, isDesktop: false };
    } else if (width >= DEVICE_BREAKPOINT.MOBILE && width <= DEVICE_BREAKPOINT.DESKTOP) {
      return { deviceType: 'tablet', isMobile: false, isTablet: true, isDesktop: false };
    } else {
      return { deviceType: 'desktop', isMobile: false, isTablet: false, isDesktop: true };
    }
  };

  useEffect(() => {
    const updateDeviceType = () => {
      setDeviceInfo(getDeviceType());
    };

    updateDeviceType();

    window.addEventListener('resize', updateDeviceType);

    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  return deviceInfo;
};

export default useDeviceType;
